import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
//import { fetchCount } from './counterAPI';

const initialState = {
  user: null,
  isLoading: false,
  errorMessageVisible: false,
  errorMessageText: "",
};

export const mainSlice = createSlice({
  name: "main",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setUser: (state, action) => {
      //console.log('setUser', JSON.stringify(action.payload))
      state.user = action.payload;
    },

    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },

    setErrorMessage: (state, action) => {
      state.errorMessageVisible = action.payload.visible;
      state.errorMessageText = action.payload.text;
    },
  },
});

export const { setUser, setIsLoading, setErrorMessage } = mainSlice.actions;

export const userSelector = (state) => {
  return state.main.user;
};

export const isLoadingSelector = (state) => {
  return state.main.isLoading;
};

export const actions = mainSlice.action;

export const mainSelectors = { isLoadingSelector, userSelector };

export default mainSlice.reducer;
